export const BANNER_BUTTON_ID_TEXT = "hero-banner-section-button";
export const BREAK_POINT_WIDTH = 768;

export const SETTINGS = {
    slidesToShow: 1,
    autoplay: true,
    autoPlaySpeed: 200,
    speed: 500,
    cssEase: "linear",
    infinite: true,
    arrows: false,
    draggable: true,
};
